import { EditingInputRow } from 'modules/frequencyManagement/components/optimize/Optimize.styles';
import { OptimizeInputFields } from 'modules/frequencyManagement/components/optimize/OptimizeInputFields';
import { OptimizeNewEditTestId } from 'modules/frequencyManagement/components/optimize/Optimize.constants';
import { OptimizeFormLabel } from 'modules/frequencyManagement/components/optimize/OptimizeFormLabel';
import {
  SchemaFormKeys,
  OPTIMIZE_MIN_ALLOWED,
  OPTIMIZE_MAX_ALLOWED,
} from 'modules/frequencyManagement/contexts/FormProvider';
import { OptimizeBaseProps } from 'modules/frequencyManagement/components/optimize/Optimize.types';
import { ConnectedFormMultiField } from 'modules/frequencyManagement/components/connectedFormMultiField/ConnectedFormMultiField';

export const OptimizeNewEdit = ({ rootName }: OptimizeBaseProps) => {
  const minName = rootName ? `${rootName}.${OPTIMIZE_MIN_ALLOWED}` : OPTIMIZE_MIN_ALLOWED;
  const maxName = rootName ? `${rootName}.${OPTIMIZE_MAX_ALLOWED}` : OPTIMIZE_MAX_ALLOWED;
  return (
    <ConnectedFormMultiField
      data-test={OptimizeNewEditTestId}
      names={[minName, maxName] as SchemaFormKeys[]}
      helpText="If unable to find an optimum, the maximum cap will be used by default."
      labelText={<OptimizeFormLabel />}
    >
      <EditingInputRow>
        <OptimizeInputFields rootName={rootName} />
      </EditingInputRow>
    </ConnectedFormMultiField>
  );
};
